var insert = require('insert-css');
var normalize = require('./normalize');

insert(normalize);



//////////////////
// WEBPACK FOOTER
// ./~/normalize-css/index.js
// module id = 107
// module chunks = 0